module.exports = "<p>\n  view-requests works!\n</p>\n"